import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectTeams } from '../../../../selectors/authenticationContext.selectors';

type ProjectSourceId = string;
type TenantId = string;

export type ProjectTenantMappings = Record<ProjectSourceId, TenantId>;

export const useGetSourceTenantMappings = () => {
	const teams = useSelector(selectTeams);

	const projectSourceTenantMapping = useMemo(() => {
		const mappingSet = new Set<[ProjectSourceId, TenantId]>();

		teams.forEach(team => {
			if (team.projectSourceId)
				mappingSet.add([team.projectSourceId, team.tenantId]);
		});

		// Convert the Set to an object before returning
		return Object.fromEntries(mappingSet);
	}, [teams]);

	return projectSourceTenantMapping;
};
